import React from 'react'

const CompanyHistory = ({information}) => {

    const {_id, title, history, img} = information;
  return (
    <div>
        <h1 className='font-bold text-3xl py-2 text-center'>{title}</h1>
            <img src={img} alt="" />
        <p>{history}</p>
    </div>
  )
}

export default CompanyHistory